module.exports = __webpack_public_path__ + "img/blockfills.f625d270.svg";